// import simpleParallax from 'simple-parallax-js';

export default {
  init($element) {

  },
  finalize($element) {

    // $element.find('img.image').each(function() {
    //   var imageEl = $(this).get()[0];
    //   new simpleParallax(imageEl, {
    //     scale: 1.15,
    //   });
    // });

    // Custom parallax for the colour text blocks
    // if ($(window).width() >= 992) {
    //   $element.find('.content-wrap').each(function() {
    //     if (!$(this).hasClass('content-background-none')) {
    //       const $this = $(this);
    //       const originalTop = parseInt($(this).css('top').replace('px', ''));
    //       const offsetY = $(this).offset().top;
    //       const elHeight = $(this).height();
    //       const sensitivity = 50;
    //       const newTop = originalTop - sensitivity;

    //       $(this).css('top', newTop + 'px');

    //       $(window).on('scroll', function() {
    //         const scrollY = $(window).scrollTop();
    //         const winHeight = $(window).height();

    //         if (scrollY + winHeight <= offsetY) {
    //           $this.css('top', newTop + 'px');
    //         } else if (scrollY >= offsetY + elHeight) {
    //           $this.css('top', originalTop + 'px');
    //         } else {
    //           // In range.
    //           const ratio = 1 - ((offsetY - scrollY + elHeight) / (winHeight + elHeight));
    //           const shiftAmount = ratio * sensitivity;
    //           $this.css('top', newTop + shiftAmount + 'px');
    //         }
    //       });
    //     }
    //   });
    // }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/flexible/leftRightImageAndText.js